import { IdResource } from "../../../../constants/IdResource";
export var checkIsResourceGold = function (path) { return function (action, state$, dependencies) {
    return action.resourceId === IdResource.Gold ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/inventory/checks/checkIsResourceGold.ts
// module id = 1905
// module chunks = 3